import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const routes = [
  {
    path: "*",
    component: () => import("@/components/NotFound")
  }
];
const router = new Router({
  mode: 'history',
  routes,
  base: process.env.BASE_URL,
});



router.beforeEach((to, from, next) => {
  next();
});


export default router;